import { Period } from 'screens/Analytics/constants'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { reportError } from 'utils/error'
import { buildErrorMessage } from 'utils'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery } from 'react-query'

export type SummaryData = {
  current_period: number | null
  previous_period: number | null
}

interface Data {
  total_posts: SummaryData
  hours_saved: SummaryData
  followers: SummaryData
  impressions: SummaryData
  profile_views: SummaryData
}

export const fetchMetricsSummary = async ({
  period,
  workspaceId,
  externalIntegrationId,
}: {
  period: Period
  workspaceId: number
  externalIntegrationId: number
}) => {
  const response = await sendToApi<Data>(
    `/w/${workspaceId}/metric_snapshots/summary?period=${period}&external_integration_id=${externalIntegrationId}
    `,
    {
      method: 'GET',
    },
  )

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError('Failed to fetch metrics summary', {
      metaData: {
        response: response.data,
      },
    })
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useMetricsSummary = ({
  period,
  externalIntegrationId,
}: {
  period: Period
  externalIntegrationId: number
}) => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data, Error>(
    ['metrics_summary', period, externalIntegrationId],
    () => fetchMetricsSummary({ period, workspaceId, externalIntegrationId }),
    {
      enabled: !!workspaceId && !!externalIntegrationId,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  )
}
